import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import titleCaseString from "../../utils/titleCaseUtils";
const UserDetails = ({ selectedItem }) => {

    const user_status = selectedItem.user_status

    return (
        <>
            {selectedItem &&

                <>
                    <Helmet>
                        <link rel="stylesheet" href="/iusevolutione/assets/vendor/css/pages/page-profile.css" />
                    </Helmet>


                    <div className="container-xxl flex-grow-1   p-0 m-0">
                        <div className="col-12">
                            <div className="card mb-4">
                                <div className="user-profile-header-banner">
                                    <img src="../assets/img/pages/profile-banner.png" alt="Banner image" className="rounded-top" />
                                </div>
                                <div className="user-profile-header d-flex flex-column flex-sm-row text-sm-start text-center mb-4">
                                    <div className="flex-shrink-0 mt-n2 mx-sm-0 mx-auto">
                                        <img src="../assets/img/avatars/1.png" alt="user image" className="d-block h-auto ms-0 ms-sm-4 rounded user-profile-img" />
                                    </div>
                                    <div className="flex-grow-1 mt-3 mt-sm-5">
                                        <div className="d-flex align-items-md-end align-items-sm-start align-items-center justify-content-md-between justify-content-start mx-4 flex-md-row flex-column gap-4">
                                            <div className="user-profile-info">
                                                <h4>{selectedItem.first_name?.toUpperCase() +" " + selectedItem.last_name?.toUpperCase()}</h4>
                                                <ul className="list-inline mb-0 d-flex align-items-center flex-wrap justify-content-sm-start justify-content-center gap-2">
                                                    <li className="list-inline-item fw-medium"><i className="bx bx-pen" /> UX Designer</li>
                                                    <li className="list-inline-item fw-medium"><i className="bx bx-map" /> Vatican City</li>
                                                    <li className="list-inline-item fw-medium">
                                                        <i className="bx bx-calendar-alt" /> Joined April 2021
                                                    </li>
                                                </ul>
                                            </div>
                                            <a href="javascript:void(0)" className={`btn btn-${user_status.toLowerCase()=="activated" ? "danger" : "success"} text-nowrap`}>
                                                <i className={`bx bx-user-${user_status.toLowerCase()=="activated" ? "x" : "check"} me-1`} />
                                                
                                                {user_status.toLowerCase()=="deactivated" || user_status.toLowerCase()=="pending" ? "Activate this account" : "Deactivate this account"}

                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div className="row">
                            <div className="col-xl-5 col-lg-5 col-md-5">
                                {/* About User */}
                                <div className="card mb-4">
                                    <div className="card-body">
                                        <small className="text-muted text-uppercase">About</small>
                                        <ul className="list-unstyled mb-4 mt-3">
                                            <li className="d-flex align-items-center mb-3">
                                                <i className="bx bx-user" /><span className="fw-medium mx-2">Full Name:</span> <span>{titleCaseString(selectedItem.fullname)}</span>
                                            </li>
                                            <li className="d-flex align-items-center mb-3">
                                                <i className="bx bx-check" /><span className="fw-medium mx-2">Status:</span> <span  className={`${selectedItem.user_status.toLowerCase()=="activated" ? "" : "text-danger"}`}>{titleCaseString(selectedItem.user_status)}</span>
                                            </li>
                                            <li className="d-flex align-items-center mb-3">
                                                <i className="bx bx-star" /><span className="fw-medium mx-2">Role:</span> <span>Developer</span>
                                            </li>
                                            <li className="d-flex align-items-center mb-3">
                                                <i className="bx bx-flag" /><span className="fw-medium mx-2">Country:</span> <span>USA</span>
                                            </li>
                                            <li className="d-flex align-items-center mb-3">
                                                <i className="bx bx-detail" /><span className="fw-medium mx-2">Languages:</span>
                                                <span>English</span>
                                            </li>
                                        </ul>
                                        <small className="text-muted text-uppercase">Contacts</small>
                                        <ul className="list-unstyled mb-4 mt-3">
                                            <li className="d-flex align-items-center mb-3">
                                                <i className="bx bx-phone" /><span className="fw-medium mx-2">Contact:</span>
                                                <span>(123) 456-7890</span>
                                            </li>
                                            <li className="d-flex align-items-center mb-3">
                                                <i className="bx bx-chat" /><span className="fw-medium mx-2">Skype:</span> <span>john.doe</span>
                                            </li>
                                            <li className="d-flex align-items-center mb-3">
                                                <i className="bx bx-envelope" /><span className="fw-medium mx-2">Email:</span>
                                                <span>john.doe@example.com</span>
                                            </li>
                                        </ul>
                                        <small className="text-muted text-uppercase">Teams</small>
                                        <ul className="list-unstyled mt-3 mb-0">
                                            <li className="d-flex align-items-center mb-3">
                                                <i className="bx bxl-github text-primary me-2" />
                                                <div className="d-flex flex-wrap">
                                                    <span className="fw-medium me-2">Backend Developer</span><span>(126 Members)</span>
                                                </div>
                                            </li>
                                            <li className="d-flex align-items-center">
                                                <i className="bx bxl-react text-info me-2" />
                                                <div className="d-flex flex-wrap">
                                                    <span className="fw-medium me-2">React Developer</span><span>(98 Members)</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                {/*/ About User */}
                            </div>
                            <div className="col-xl-7 col-lg-7 col-md-7">
                                {/* Activity Timeline */}
                                <div className="card card-action mb-4">
                                    <div className="card-header align-items-center">
                                        <h5 className="card-action-title mb-0"><i className="bx bx-list-ul me-2" />Activity Timeline</h5>
                                        <div className="card-action-element">
                                            <div className="dropdown">
                                                <button type="button" className="btn dropdown-toggle hide-arrow p-0" data-bs-toggle="dropdown" aria-expanded="false">
                                                    <i className="bx bx-dots-vertical-rounded" />
                                                </button>
                                                <ul className="dropdown-menu dropdown-menu-end">
                                                    <li><a className="dropdown-item" href="javascript:void(0);">Share timeline</a></li>
                                                    <li><a className="dropdown-item" href="javascript:void(0);">Suggest edits</a></li>
                                                    <li>
                                                        <hr className="dropdown-divider" />
                                                    </li>
                                                    <li><a className="dropdown-item" href="javascript:void(0);">Report bug</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <ul className="timeline ms-2">
                                            <li className="timeline-item timeline-item-transparent">
                                                <span className="timeline-point-wrapper"><span className="timeline-point timeline-point-warning" /></span>
                                                <div className="timeline-event">
                                                    <div className="timeline-header mb-1">
                                                        <h6 className="mb-0">Client Meeting</h6>
                                                        <small className="text-muted">Today</small>
                                                    </div>
                                                    <p className="mb-2">Project meeting with john @10:15am</p>
                                                    <div className="d-flex flex-wrap">
                                                        <div className="avatar me-3">
                                                            <img src="../../assets/img/avatars/3.png" alt="Avatar" className="rounded-circle" />
                                                        </div>
                                                        <div>
                                                            <h6 className="mb-0">Lester McCarthy (Client)</h6>
                                                            <span>CEO of Infibeam</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li className="timeline-item timeline-item-transparent">
                                                <span className="timeline-point-wrapper"><span className="timeline-point timeline-point-info" /></span>
                                                <div className="timeline-event">
                                                    <div className="timeline-header mb-1">
                                                        <h6 className="mb-0">Create a new project for client</h6>
                                                        <small className="text-muted">2 Day Ago</small>
                                                    </div>
                                                    <p className="mb-0">Add files to new design folder</p>
                                                </div>
                                            </li>
                                            <li className="timeline-item timeline-item-transparent">
                                                <span className="timeline-point-wrapper"><span className="timeline-point timeline-point-primary" /></span>
                                                <div className="timeline-event">
                                                    <div className="timeline-header mb-1">
                                                        <h6 className="mb-0">Shared 2 New Project Files</h6>
                                                        <small className="text-muted">6 Day Ago</small>
                                                    </div>
                                                    <p className="mb-2">
                                                        Sent by Mollie Dixon
                                                        <img src="../../assets/img/avatars/4.png" className="rounded-circle ms-3" alt="avatar" height={20} width={20} />
                                                    </p>
                                                    <div className="d-flex flex-wrap gap-2">
                                                        <a href="javascript:void(0)" className="me-3">
                                                            <img src="../../assets/img/icons/misc/pdf.png" alt="Document image" width={20} className="me-2" />
                                                            <span className="h6">App Guidelines</span>
                                                        </a>
                                                        <a href="javascript:void(0)">
                                                            <img src="../../assets/img/icons/misc/doc.png" alt="Excel image" width={20} className="me-2" />
                                                            <span className="h6">Testing Results</span>
                                                        </a>
                                                    </div>
                                                </div>
                                            </li>
                                            <li className="timeline-item timeline-item-transparent">
                                                <span className="timeline-point-wrapper"><span className="timeline-point timeline-point-success" /></span>
                                                <div className="timeline-event pb-0">
                                                    <div className="timeline-header mb-1">
                                                        <h6 className="mb-0">Project status updated</h6>
                                                        <small className="text-muted">10 Day Ago</small>
                                                    </div>
                                                    <p className="mb-0">Woocommerce iOS App Completed</p>
                                                </div>
                                            </li>
                                            <li className="timeline-end-indicator">
                                                <i className="bx bx-check-circle" />
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </>
            }
        </>
    );
}

export default UserDetails;